
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { useTranslation } from "react-i18next";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { panelTitle, PanelHeader } from "./PanelHeader.js";
import { ofArray, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Help_Chat_2 from "../../public/assets/icons/Help_Chat_2.svg";
import { supportMeetingUrl, helpCenterUrl } from "../Widgets/SupportHelp.js";

export const embedContainerId = "support-chat-embed";

function QuickLink(props) {
    return reactElement("a", {
        "data-test-id": props.TestId,
        href: props.Href,
        target: "_blank",
        rel: "noreferrer",
        className: join(" ", ["h-8", "px-3", "rounded-full", "border", "border-border", "bg-white", "text-xs", "font-medium", "text-black", "flex", "items-center", "hover:bg-background"]),
        children: props.Label,
    });
}

export function SupportPanelHeader(props) {
    let elems_5;
    const t = useTranslation()[0];
    const phoneNumber = t("global.phone_number");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "shrink-0"])], (elems_5 = toList(delay(() => {
        let elems_3, elems_1, elems, elems_2;
        return append(singleton(createElement(PanelHeader, {
            Actions: empty(),
            OnClose: props.OnClose,
            TestId: "activity-panel-support",
            Title: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "min-w-0"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-9", "w-9", "shrink-0", "rounded-full", "bg-[#E3F4F1]", "text-primary", "flex", "items-center", "justify-center"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems = [Help_Chat_2()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "min-w-0"])], (elems_2 = [panelTitle(t("activity_bar.support_chat")), reactElement("span", {
                className: join(" ", ["text-xs", "text-text-muted", "truncate"]),
                children: t("activity_bar.support_subtitle"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))),
        })), delay(() => {
            let elems_4, Label, Label_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2", "px-4", "py-3", "border-b", "border-border"])], (elems_4 = [createElement(QuickLink, (Label = t("activity_bar.help_center"), {
                Href: helpCenterUrl(props.CurrentUser.Language),
                Label: Label,
                TestId: "support-panel-help-center",
            })), createElement(QuickLink, {
                Href: supportMeetingUrl,
                Label: t("support.meeting_button"),
                TestId: "support-panel-meeting",
            }), createElement(QuickLink, (Label_2 = t("activity_bar.call"), {
                Href: concat("tel:", ...phoneNumber),
                Label: Label_2,
                TestId: "support-panel-call",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                const matchValue = props.WidgetState;
                switch (matchValue.tag) {
                    case 3:
                        return singleton(reactElement("div", {
                            "data-test-id": "support-panel-hidden",
                            className: join(" ", ["px-4", "py-3", "text-sm", "text-text-muted"]),
                            children: t("activity_bar.support_not_available_here"),
                        }));
                    case 4:
                        return singleton(reactElement("div", {
                            "data-test-id": "support-panel-failed",
                            className: join(" ", ["mx-4", "my-3", "px-3", "py-2", "rounded-lg", "bg-light-red", "text-sm", "text-red"]),
                            children: t("activity_bar.support_unavailable"),
                        }));
                    case 2: {
                        return empty_1();
                    }
                    default:
                        return singleton(reactElement("div", {
                            "data-test-id": "support-panel-loading",
                            className: join(" ", ["px-4", "py-3", "text-sm", "text-text-muted"]),
                            children: t("activity_bar.support_loading"),
                        }));
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

